import ModusServiceModel from "../ModusServiceModel";
import ResultNutrientModel from "./ResultNutrientModel";

export default class ResultNutrientElementModel extends ModusServiceModel {
  modelName() {
    return 'result-nutrient-elements';
  }
  icon() {
    return 'atom';
  }
  defaults() {
    return {
      id: null,
      result_nutrient_id: null,
      result_nutrient: null,
      element: null,
      value: null,
      unit: null,
      result_test_id: null,
      result_nutrient_element_value_type_id: null,
      result_nutrient_element_value_desc_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_nutrient_id: (val) => (this.nullStringMutator(val)),
      element: (val) => (this.nullStringMutator(val)),
      value: (val) => (this.nullStringMutator(val)),
      unit: (val) => (this.nullStringMutator(val)),
      result_test_id: (val) => (this.nullStringMutator(val)),
      result_nutrient_element_value_type_id: (val) => (this.nullStringMutator(val)),
      result_nutrient_element_value_desc_id: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getResultNutrient() {
    return this.getRelatedModel(ResultNutrientModel, 'result_nutrient');
  }
}
